import * as React from 'react';

export default function ReceiptLongIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <mask
        id="prefix__a"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={24}
      >
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#prefix__a)">
        <path
          d="M6 22a2.893 2.893 0 01-2.125-.875A2.893 2.893 0 013 19v-3h3V2l1.5 1.5L9 2l1.5 1.5L12 2l1.5 1.5L15 2l1.5 1.5L18 2l1.5 1.5L21 2v17c0 .833-.292 1.542-.875 2.125A2.893 2.893 0 0118 22H6zm12-2c.283 0 .52-.096.712-.288A.965.965 0 0019 19V5H8v11h9v3c0 .283.096.52.288.712A.965.965 0 0018 20zM9 9V7h6v2H9zm0 3v-2h6v2H9zm8-3a.965.965 0 01-.712-.288A.965.965 0 0116 8c0-.283.096-.521.288-.713A.967.967 0 0117 7c.283 0 .52.096.712.287.192.192.288.43.288.713s-.096.52-.288.712A.965.965 0 0117 9zm0 3a.965.965 0 01-.712-.288A.965.965 0 0116 11c0-.283.096-.521.288-.713A.967.967 0 0117 10c.283 0 .52.096.712.287.192.192.288.43.288.713s-.096.52-.288.712A.965.965 0 0117 12zM6 20h9v-2H5v1c0 .283.096.52.287.712.192.192.43.288.713.288z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
